import React from 'react';
import {SPLIT_DELIMITER} from "../../../placement/const";
import CancelIcon from "@material-ui/icons/Cancel";
import {SubmittedRequestListAction, SubmittedRequestListFilterValue} from "./submittedRequestListReducer";
import {asQueryParam} from "./SubmittedRequestListFilter";
import {
    SubmittedRequestTypeMap, SubmittedStatusMap,
} from "./SubmittedRequestDomain";
import {formatLocalDateString} from "../../../common/util/date";


type SubmittedRequestListFilterBadgeProps = {
    filter: SubmittedRequestListFilterValue
    dispatch: React.Dispatch<SubmittedRequestListAction>
    className?: string
}

export function SubmittedRequestListFilterBadge({filter, dispatch, className}: SubmittedRequestListFilterBadgeProps) {
    let values: Array<string> = [];

    const params = asQueryParam(filter);
    if (params.requestType) {
        values = values.concat(params.requestType);
    }
    if (params.statuses) {
        values = values.concat(params.statuses);
    }
    if (params.submittedDateFrom) {
        values = values.concat(`Submitted Date From: ${formatLocalDateString(params.submittedDateFrom)}`);
    }
    if (params.submittedDateTo) {
        values = values.concat(`Submitted Date To: ${formatLocalDateString(params.submittedDateTo)}`);
    }
    if (params.closedDateFrom) {
        values = values.concat(`Closed Date From: ${formatLocalDateString(params.closedDateFrom)}`);
    }
    if (params.closedDateTo) {
        values = values.concat(`Closed Date To: ${formatLocalDateString(params.closedDateTo)}`);
    }
    if (params.submittedBy?.length) {
        values = values.concat(params.submittedBy.map((s) => `Submitted By: ${s}`));
    }

    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            if (value.includes("Submitted Date From:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, submittedDateFrom: null}});
                return;
            }
            if (value.includes("Submitted Date To:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, submittedDateTo: null}});
                return;
            }
            if (value.includes("Closed Date From:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, closedDateFrom: null}});
                return;
            }
            if (value.includes("Closed Date To:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, closedDateTo: null}});
                return;
            }
            if (value.startsWith("Submitted By: ")) {
                const nameToRemove = value.replace("Submitted By: ", "");
                const current = filter.submittedBy ? filter.submittedBy.split(SPLIT_DELIMITER).map((s) => s.trim()).filter(Boolean) : [];
                const updated = current.filter((n) => n !== nameToRemove);
                dispatch({type: 'SET_FILTER', filter: {...filter, submittedBy: updated.length ? updated.join(SPLIT_DELIMITER) : null}});
                return;
            }

            const keyArr = [
                "status",
                "requestType",
            ];

            const splitFilterValues = (val: string) => val.split(';').map((s) => s.trim()).filter(Boolean);
            for (let i = 0; i < keyArr.length; i++) {
                const key = keyArr[i] as "status" | "requestType"
                const filterValueForKey = filter[key];
                if (filterValueForKey == null) continue;
                const filterOptions = splitFilterValues(filterValueForKey);
                if (filterOptions.includes(value)) {
                    const updated = filterOptions.filter((val) => val !== value);
                    const newFilter = {...filter};
                    newFilter[key] = updated.length ? updated.join(SPLIT_DELIMITER) : null;
                    dispatch({type: 'SET_FILTER', filter: newFilter});
                    return
                }
            }
        }
    }

    const displayValue = (value: string) => {
        if (SubmittedRequestTypeMap.get(value)) {
            return SubmittedRequestTypeMap.get(value);
        }

        if (SubmittedStatusMap.get(value)) {
            return SubmittedStatusMap.get(value);
        }

        return value;
    }

    if (values.length === 0) {
        return <div/>;
    }

    return (
        <div className={`flex items-start min-w-0 ${className ?? 'pl-5'}`}>
            <div className='pt-2 pr-5 flex-grow-0 shrink-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {displayValue(value)}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}


